module.exports = "/_next/static/images/prestaShop16-43dee2e1e62161a29887470f58160b51.png";